import styled from "@emotion/styled";

import LinearProgress from "@mui/material/LinearProgress";
import Backdrop from "../Backdrop";
import theme from "../../theme/theme";
import { useEffect, useState } from "react";

const LinearProgressBar = styled(LinearProgress)`
  height: 20px;
  width: 400px;
  border-radius: 15px;
  background-color: ${theme.colors.bg};
  @media (max-width: 480px) {
    height: 10px;
    width: 200px;
  }

  & .MuiLinearProgress-barColorPrimary {
    background-color: ${theme.colors.primary};
  }
`;

const LoaderWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .info {
    display: flex;
    justify-content: space-between;
    color: white;
    font-weight: bold;
    font-size: 20px;
    width: 400px;
    @media (max-width: 480px) {
      width: 200px;
    }
  }
`;

const LoadingBar = ({ setIsLoaded, isLoading }) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (!isLoading) {
      const id = setTimeout(() => {
        setIsLoaded(true);
        clearTimeout(id);
      }, theme.timeOuts.loadTime);
    }
  }, [isLoading, setIsLoaded]);

  useEffect(() => {
    if (isLoading) {
      if (progress < 50) {
        setTimeout(() => {
          setProgress(progress + 1);
        }, 100);
      } else if (progress < 60) {
        setTimeout(() => {
          setProgress(progress + 1);
        }, 150);
      } else if (progress < 70) {
        setTimeout(() => {
          setProgress(progress + 1);
        }, 200);
      } else if (progress < 80) {
        setTimeout(() => {
          setProgress(progress + 1);
        }, 300);
      } else if (progress < 90) {
        setTimeout(() => {
          setProgress(progress + 1);
        }, 700);
      } else if (progress < 95) {
        setTimeout(() => {
          setProgress(progress + 1);
        }, 1000);
      } else if (progress < 99) {
        setTimeout(() => {
          setProgress(progress + 1);
        }, 5000);
      }
    } else {
      setProgress(100);
    }
  }, [isLoading, progress]);

  return (
    <Backdrop>
      <LoaderWrapper>
        <div className="info">
          <p>Loading...</p>
          <p>{progress}%</p>
        </div>
        <LinearProgressBar variant="determinate" value={progress} />
      </LoaderWrapper>
    </Backdrop>
  );
};

export default LoadingBar;
